import styled from 'styled-components';
import { colors } from '../colors';

interface colProps {
	width?: string;
	flex?: string;
	maxWidth?: string;
	minWidth?: string;
	padding?: string;
	margin?: string;
	projectClientInfo?: boolean;
	projectDateInfo?: boolean;
	dFlex?: boolean;
	justifyContentEnd?: boolean;
	flexWrap?: boolean;
	marginLeft?: string;
	paddingLeft?: string;
	documentCardsBLock?: boolean;
	textEllipsis?: boolean;
	productinfoCol?: boolean;
	projectIndividualLeft?: boolean;
	projectIndividualRight?: boolean;
	forgotYourPassword?: boolean;
	loginButton?: boolean;
	newUser?: boolean;
	selectDocumentType?: boolean;
	dateFieldBlock?: boolean;
	imgSliderBlock?: boolean;
	pdfImgViewer?: boolean;
	scopeDocumentList?: boolean;
	socialMediaLoginButton?: boolean;
}

const Col = styled.div<colProps>`
	box-sizing: border-box;
	width: 100%;
	width: ${({ width }) => width}!important;
	flex: ${({ flex }) => flex}!important;
	max-width: ${({ maxWidth }) => maxWidth};
	min-width: ${({ minWidth }) => minWidth};
	padding: ${({ padding }) => padding}!important;
	margin: ${({ margin }) => margin}!important;
	margin-left: ${({ marginLeft }) => marginLeft}!important;
	padding-left: ${({ paddingLeft }) => paddingLeft}!important;
	position: relative;
	flex-basis: 0;
	-webkit-box-flex: 1;
	flex-grow: 1;
	max-width: 100%;
	padding-right: 15px;
	padding-left: 15px;
	
	${({ projectClientInfo }) =>
		projectClientInfo &&
		`flex:0 0 200px!important;
	`}
	${({ productinfoCol }) =>
		productinfoCol &&
		`flex:0 0 none!important;
	`}
	${({ textEllipsis }) =>
		textEllipsis &&
		`white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 100px;
	`}
	${({ projectDateInfo }) =>
		projectDateInfo &&
		`flex:0 0 150px!important;
	`}
	${({ dFlex }) =>
		dFlex &&
		`display:flex;
	`}
	${({ justifyContentEnd }) =>
		justifyContentEnd &&
		`justify-content: flex-end;
	`}
	${({ flexWrap }) =>
		flexWrap &&
		`flex-wrap: wrap;
	`}
	${({ documentCardsBLock }) =>
		documentCardsBLock &&
		`position: relative;
		@media (min-width: 1366px){
			flex: 0 0 20%;
			max-width: 20%;
			order: 1;
		}
		@media (max-width:1366px){
			flex: 0 0 25%;
			max-width: 25%;
			order: 1;
		}
		@media (max-width: 960px){
			flex: 0 0 33.33%;
			max-width: 33.33%;
		}
		@media (max-width: 640px){
			flex: 0 0 50%;
			max-width: 50%;
		}
		@media (max-width: 592px){
			flex: 0 0 100%;
			max-width: 100%;
		}
	`}
	${({ projectIndividualLeft }) =>
		projectIndividualLeft &&
		`width:194px;
		flex:0 0 194px;
		overflow: hidden;
		overflow-y: auto;
		max-height: calc(100vh - 336px);
		@media screen and (max-width: 640px) {
			overflow-y: hidden;
			overflow-x: auto;
			max-height: fit-content;
			display: flex;
			flex:0 0 100%;
			width:100%;
		}
	`}
	${({ forgotYourPassword }) =>
		forgotYourPassword &&
		`padding-top: 25px;
		button{
			float: right;
			line-height: 16px!important;
			min-height: auto;
			font-size: 13px;
		}
		@media (max-width:530px){
			button{
				font-size:12px!important;
			}
		}
	`}
	${({ newUser }) =>
		newUser &&
		`display: flex;
		justify-content: center;
		margin-top:20px;
		button{
			line-height: normal!important;
			min-height: auto;
			font-size: 13px;
			margin-left: 5px;
			margin-top: -2px;
		}
		@media (max-width:530px){
			button{
				font-size:12px!important;
			}
		}
	`}
	${({ loginButton }) =>
		loginButton &&
		`display: flex;
		align-items: center;
		justify-content: center;
		padding-top:0;
		margin-top:32px;
		button{
			float:right;
			font-family: 'RubikMedium';
			font-size: 15px;
			line-height: 18px;
			min-width:126px;
			height:40px;
		}
		@media (max-width:530px){
			margin:20px 20px 10px;
		}
	`}
	${({ selectDocumentType }) =>
		selectDocumentType &&
		`flex: 0 0 450px;
    	padding-left: 30px;
		button{
			float: left;
			border-radius: 50px;
			margin: 0 10px 10px 0;
			font-family: 'RubikMedium';
			font-size: 13px;
			:hover{
				background-color:${colors.BlueBase};
				border:1px solid ${colors.BlueBase};
				color:${colors.White}!important;
			}
		}
	`}
	${({ dateFieldBlock }) =>
		dateFieldBlock &&
		`align-items: flex-start;
		margin-bottom:10px;
		button{
			margin-top: 0;
			margin-left: 10px;
			height: 36px;
		}
		.app-c-doc-select{
			flex:0 0 300px;
		}
	`}
	${({ imgSliderBlock }) =>
		imgSliderBlock &&
		`border: 1px solid #ddd;
		border-radius: 10px;
		padding: 20px;
	`}
	${({ pdfImgViewer }) =>
		pdfImgViewer &&
		`border: 1px solid #ddd;
		border-radius: 5px;
		padding: 15px;
		overflow: hidden;
		#pdfDocument{
			margin: auto;
    width: 100%;
	max-height: calc(100vh - 392px);
	overflow: hidden;
		canvas{
		width: 100% !important;
		height: calc(100vh - 392px)!important;
		// object-fit: contain;
	}
	.img-magnifier-glass {
		position: absolute !important;
		border: 3px solid #000 !important;
		border-radius: 50% !important;
		cursor: none !important;
	
		width: 70px !important;
		height: 70px !important;
		z-Index:9999 !important;
	  }
	  img-magnifier-container{
		position:relative;
	  }
	  pg-container{
		position:relative;
	  }
	  .react-pdf__Page__textContent {display: none;}
	`}
	
	${({ scopeDocumentList }) =>
		scopeDocumentList &&
		`flex-basis: unset;
	  	width:100%;
	  .column-block{
		display: flex;
		justify-content: center;
		align-items: center;
	  }
	  `}

	${({ socialMediaLoginButton }) =>
		socialMediaLoginButton &&
		`display: flex;
		align-items: center;
		justify-content: center;
		padding-top:0;
		margin-top:32px;
		button{
			float:right;
			font-family: 'RubikMedium';
			font-size: 15px;
			line-height: 18px;
			min-width:250px;
			height:40px;
			
			justify-content: left;
		}
		@media (max-width:530px){
			margin:20px 20px 10px;
		}
	`}
`;
export default Col;
